import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Dialog, DialogActions, Divider } from '@material-ui/core';
import { flagIcon } from '../../constants/Helpers';
import ProcessingLoader from '../shared/ProcessingLoader';
import AppService from '../../services/AppService';

const ResetSendingModal = ({
  isResetPopupOpen,
  setIsResetPopupOpen,
  occasionId,
  fetchOccasionById,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await AppService.resetSendingStatus(occasionId);
      toast.success('تم اعادة ضبط الارسال بنجاح');
      setIsResetPopupOpen(false);
      setIsLoading(false);
      setTimeout(() => {
        fetchOccasionById(occasionId);
      }, 500);
    } catch (e) {
      toast.error(e?.response?.data?.message ?? 'فشل في اعادة ضبط الارسال');
      setIsLoading(false);
    }
  };

  return (
    <div className="">
      <Dialog
        open={isResetPopupOpen}
        onClose={() => setIsResetPopupOpen((prev) => !prev)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ProcessingLoader /> <span>جاري اعادة الضبط ...</span>
          </div>
        ) : (
          <>
            <div
              style={{
                padding: 30,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src={flagIcon.falseIcon} style={{ width: 30, marginRight: 5 }} />
              هل انت متأكد من اعادة ضبط الارسال؟
            </div>
            <Divider />
          </>
        )}
        <DialogActions
          style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}
        >
          <Button
            variant="contained"
            type="submit"
            onClick={() => setIsResetPopupOpen(false)}
            color="default"
          >
            الغاء
          </Button>
          <Button
            style={{ backgroundColor: '#006782', color: 'white', margin: 5 }}
            variant="contained"
            type="submit"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            نعم
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ResetSendingModal;
